import { render } from "./Home.vue?vue&type=template&id=1703cfb9&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=1703cfb9&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1703cfb9"]])

export default __exports__